import {
	Component,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { CellClickedEvent, ColDef } from 'ag-grid-community';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { LoanMetaService } from '@lmc-app/core/services/loan-meta.service';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { User } from '@sentry/angular';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class HomeComponent
	implements OnInit, OnDestroy {
	protected toggleDashboard: any;
	protected columnDefs: ColDef[] = [
		{
			field: 'Deal_Name',
			headerName: 'Name',
			cellRenderer: (params) => {
				return `<a class="noline"">${params.data.Deal_Name}</a>`;
			},
			pinned: 'left',
			minWidth: 180,
			// tooltipField: 'Deal_Name',
		},
		{
			field: 'App_Number',
			headerName: 'Loan Servicing',
			cellRenderer: (params) => {
				return `<a class="noline"">${params.data.App_Number}</a>`;
			},
			minWidth: 130,
		},
		{
			field: 'Stage',
			headerName: 'Stage',
			minWidth: 200,
			wrapText: true,
			autoHeight: true,
		},
		{
			field: 'Agency_Formula',
			headerName: 'Agency',
			minWidth: 200,
			wrapText: true,
			autoHeight: true,
		},
		{
			field: 'Collector_Formula',
			headerName: 'Collector',
			minWidth: 200,
			wrapText: true,
			autoHeight: true,
		},
		{
			field: 'Created_Time',
			headerName: 'Created',
			valueGetter: (params) =>
				this.dateFormatter.transform(params.data.Created_Time, 'mediumDate'),
		},
		{
			field: 'Referral_Date',
			headerName: 'Referral',
			valueGetter: (params) =>
				this.dateFormatter.transform(params.data.Referral_Date, 'mediumDate'),
		},
		{
			field: 'Amount',
			headerName: 'Amount',
			valueGetter: (params) =>
				this.currencyFormatter.transform(
					params.data.Amount,
					'CAD',
					'symbol-narrow'
				),
		},
		{
			field: 'gdriveextension__Drive_URL',
			headerName: 'Drive',
			cellRenderer: (params) => {
				const { gdriveextension__Drive_URL } = params.data;
				return gdriveextension__Drive_URL
					? `<a target="_blank"
          href="${gdriveextension__Drive_URL}"><i class="fa fa-folder-open-o fa-lg" aria-hidden="true"></i></a>`
					: '';
			},
		},
	];

	protected readAllClientApplications: any; // Display all the applications Deals

	private searchKeyword: { keyword };
	protected showLoader: boolean;
	private readonly _onDestroy = new Subject<void>();
	roleID: number = null;
	constructor(
		private apiService: LegacyApiService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private dateFormatter: DatePipe,
		private currencyFormatter: CurrencyPipe,
		private loanMetaService: LoanMetaService,
		private readonly store: Store<State>
	) { }

	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				this.roleID = user?.roleID;
			});
		this.readAllClientApplications = [];

		this.activatedRoute?.queryParams?.subscribe((queryParams) => {
			this.toggleDashboard = queryParams?.searchKeyword;
			this.searchKeyword = {
				keyword: queryParams?.searchKeyword,
			};
			if (queryParams?.searchKeyword) {
				this.getAllClientApplications();
			}
		});
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	onCellClicked(e: CellClickedEvent) {
		const clickedCol = e.colDef.field;
		const { id, App_Number } = e.data;
		switch (clickedCol) {
			case 'Deal_Name':
				if(this.roleID === 13){
					return null;
				}else{
					return this.router.navigate(['/applications/summary', id]);
				}
			case 'App_Number':
				return this.openLoanMeta(App_Number);
			default:
				return null;
		}
	}

	// Fetch all the applications on the user management portal that has the first three letters on search bar
	// The search is based on deal name
	getAllClientApplications() {
		try {
			// Search pattern made to search on key Enter
			this.showLoader = true;
			this.apiService
				.getSearchApplication(this.searchKeyword, this.roleID)
				.subscribe((res) => {
					if (res.message.statusCode == '200') {
						this.readAllClientApplications = res.message.body.data;
						this.showLoader = false;
					} else {
						this.showLoader = false;
						this.readAllClientApplications = []; // This will clear the search area
					}
				});
		} catch (e) {
			console.log('Search error', e);
		}
	}

	//INCLUDE THIS IN THE SEARCH COMPONENT TO OPEN LOAN META FOR SPECIFIC LOAN FOR NLS (NEW COLOUMN FOR NLS OPEN)
	openLoanMeta(loan_number: string) {
		this.apiService.searchNLSLoan(loan_number).subscribe((res: any[]) => {
			if (res.length == 0) {
				alert('Loan Number cannot be found on NLS');
			} else {
				this.loanMetaService.setQueue([loan_number], loan_number, false);
				this.router.navigate(['loan-meta']);
			}
		});
	}
}
